export default __webpack_public_path__ + "static/media/card_3_paseo.fd6165ce.jpg";